import { Achievement_Types_Enum, UserAchievementFragment } from '@/gql/generated/graphql'
import { DetailText } from 'design-configuration/components'
import { AchievementDetailsModal } from '../achievements/components/achievement-details-modal'
import { useState } from 'react'

type FlairBadgeProps = {
  userAchievement: UserAchievementFragment
}

const FlairBadge = ({ userAchievement }: FlairBadgeProps) => {
  const [modalOpen, setModalOpen] = useState(false)

  const handleModalDismiss = () => {
    setModalOpen(false)
  }

  return (
    <>
      <AchievementDetailsModal
        show={modalOpen}
        onDismiss={handleModalDismiss}
        achievement={userAchievement.achievement}
        userAchievement={userAchievement}
        token={userAchievement?.token ?? undefined}
        newlyClaimed={false}
        key={userAchievement.id}
      />
      <button
        onClick={() => setModalOpen(true)}
        className={`rounded-xs group p-[1px] ${userAchievement.achievement.type === Achievement_Types_Enum.Historical ? 'bg-gradient-chromie' : 'bg-outline-variant hover:bg-outline'}`}
      >
        <div className="px-xs py-2xs text-on-surface rounded-xs bg-surface group-hover:bg-surface-low font-medium uppercase">
          <DetailText>{userAchievement.achievement.name}</DetailText>
        </div>
      </button>
    </>
  )
}

export default FlairBadge
